import { createContext, useContext, type ReactNode } from 'react';
import type {
  ParsedEdfInfo,
  TherapyGeneration,
} from '@lmt/signal-viewer-processor';
import type { FileUploadData } from '../utils/file-upload';

export type FileSessionValue = {
  isUploadMode: boolean;
  currentFileNames: string[] | undefined;
  headerGeneration: TherapyGeneration | null;
  parsedEdfInfo: ParsedEdfInfo[];
  availableSignalTypes: string[];
  dataGeneration: TherapyGeneration | null;
  onCancelUpload: () => void;
  onUploadFiles: (data: FileUploadData) => void | Promise<void>;
};

const FileSessionContext = createContext<FileSessionValue | null>(null);

export const FileSessionProvider: React.FC<{
  value: FileSessionValue;
  children: ReactNode;
}> = ({ value, children }) => (
  <FileSessionContext.Provider value={value}>
    {children}
  </FileSessionContext.Provider>
);

export const useFileSession = (): FileSessionValue => {
  const value = useContext(FileSessionContext);
  if (!value) {
    throw new Error('useFileSession must be used inside a FileSessionProvider');
  }
  return value;
};
